var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-spinner",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }